import { Component } from '@angular/core';
import { DisplayUnit } from 'src/app/panels/models/display-unit';
import { PanelType } from 'src/app/panels/models/panel-type';
import {
  KPI_PANEL_IMPORTS,
  KpiPanelComponent,
} from '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component';
import { PanelComponent } from '../../../../../panels/components/panel.component';

@PanelComponent.register
@Component({
  templateUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.html',
  styleUrl: '../../../../../panels/components/kpi/kpi-panel/kpi-panel.component.scss',
  selector: 'app-total-water-used-kpi-panel',
  imports: KPI_PANEL_IMPORTS,
})
export class TotalWaterUsedKpiPanelComponent extends KpiPanelComponent {
  public static override readonly type = PanelType.TotalWaterKpi;
  public override title = 'Totaal waterverbruik';
  public override icon = 'bi-droplet-fill';
  public override unit = DisplayUnit.M3;
}
